module.exports = __webpack_public_path__ + "img/search-icon.d08fa71a.svg";